/**
 * @deprecated Do not use it.
 * Use public state = new State(); instead
 */
export function useState<T>(state: { new (): T }) {
	return function (component: Function) {
		component.prototype.state = new state();
	};
}
